// componente para cambiar el password

import { useEffect, useState, useContext } from "react";


import { useNavigate, useParams } from "react-router-dom";

// url import
import { urls } from "../../api-urls/api-urls.js";

// components import
import { EyeFill, EyeSlashFill } from "../../components/icons/AppIcons.jsx";
import { LoadingComp } from "../../components/loading-comp/LoadingComp.jsx";


// import react translation
import { useTranslation } from "react-i18next";


// language context import
import { LangContext } from "../../context/LangContext.jsx";


// url import client
import { UrlClient } from "../../components/constants/constants.js";





export const ResetPasswdView = () => {

  // GET the language context
  const { lang } = useContext(LangContext);

  // GET the react translation
  const [t] = useTranslation("global");

  // GET the params
  const { code } = useParams();


  // GET the useNavigate
  const navigate = useNavigate();


  // state definition
  const [form, setForm] = useState({ passwd1: "", passwd2: "" });
  const [controller, setController] = useState(null); // estado para cancelar la peticion
  const [state, setState] = useState({ showPassw: false, loading: false, dataVisi: false, msg: "", updating: false, success: false, error: false });
  const [listErr, setListErr] = useState([]);


  // funcion para validar la contraseña
  const onHandleValPasswd = (passwd1 = "", passw2 = "") => {
    // expresiones regulares
    const HasUpperCase = /[A-Z]/.test(passwd1); // true si incluye mayuscula
    const HasLowerCase = /[a-z]/.test(passwd1); // true si incluye miniscula
    const HasNumber = /[0-9]/.test(passwd1); // true si incluye un numero
    const HasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(passwd1); // true si incluye uno de estos caracteres
    const HasMinLength = passwd1.length >= 8; // true si es mayor o igual a 8

    if (!HasUpperCase || !HasLowerCase || !HasNumber || !HasSpecialChar || !HasMinLength) {
      const LisErr = [
        t("ResetPasswd.mayus"),
        t("ResetPasswd.minus"),
        t("ResetPasswd.num"),
        t("ResetPasswd.carac"),
        t("ResetPasswd.numCa")
      ];
      setListErr(LisErr);

    }

    if ((HasUpperCase && HasLowerCase && HasNumber && HasSpecialChar && HasMinLength) && (passwd1 === passw2)) {
      setListErr([]);
      return true;
    }

    if (passwd1 !== passw2) {
      setListErr([t("SignUpComp.no_coinciden_pass")]);
    }

    return false;

  };


  // funcion para enviar el formulario al servidor
  const onHandleSubmit = async (event) => {
    event.preventDefault();

    if (!onHandleValPasswd(form.passwd1, form.passwd2)) {
      return;
    }

    const END_POINT = `${urls.authRoute}/new-passwd?token_recov=${code}&language=${lang}&urlC=${UrlClient}`;

    try {
      setState((val) => ({ ...val, updating: true }));
      const response = await fetch(END_POINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(form)
      });

      const data = await response.json();

      if (response.status === 200) {
        setState((val) => ({ ...val, dataVisi: false, success: true, msg: data?.msg }));
      } else {
        setState((val) => ({ ...val, msg: data?.msg, error: true }));
      }

      setState((val) => ({ ...val, updating: false }));

    } catch (error) {
      console.log(error);
    }
  }


  // funcion para consultar la informacion al servidor
  const fetchDataServ = async () => {
    const abortController = new AbortController();

    setController(abortController);

    const END_POINT = `${urls.authRoute}/know-token-recover?token_recov=${code}&language=${lang}&urlC=${UrlClient}`;

    try {
      setState((val) => ({ ...val, loading: true }));
      const response = await fetch(END_POINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      });

      const data = await response.json();

      if (response.status === 200) {
        setState((val) => ({ ...val, dataVisi: true, msg: "" }));
      } else if (response.status === 400) {
        console.log(data?.msg);
        setState((val) => ({ ...val, msg: data?.msg }));
      } else if (response.status === 404) {
        setState((val) => ({ ...val, msg: data?.msg }));
      }


      setState((val) => ({ ...val, loading: false }));

    } catch (error) {
      console.log(error);
    }
  };


  // useEffect para traer la data del servidor
  useEffect(() => {

    fetchDataServ();

    return () => {
      if (controller) {
        controller.abort();
      }
    }

  }, []);



  return (
    <div className="reset-contan-paswd">
      {
        state.error && (
          <h4 style={{ color: "var(--danger-color)" }}>{state.msg}</h4>
        )
      }

      {
        state.success && (
          <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
            <h4>{state.msg}</h4>
            <button className="btn-success" onClick={() => navigate("/")}>{t("HomeViewComp.regr_login")}</button>
          </div>
        )
      }

      {
        state.loading && (
          <LoadingComp />
        )
      }

      {
        state.dataVisi && (
          <form onSubmit={onHandleSubmit} className="card-reset fade-animation">
            <h4>{t("HomeViewComp.cambiar_passw")}</h4>

            <p className="txt-muted">{t("HomeViewComp.msg_seguridad")}</p>

            <label style={{ cursor: "auto", fontWeight: "bold", fontSize: "16px" }} className="label-pwd" htmlFor="passwd1">{t("ResetPasswd.new_pass")}</label>

            <div className="con-inp-lst">
              <input
                style={{ marginTop: "3px", marginBottom: "5px" }}
                className="input-control-text"
                type={state.showPassw ? "text" : "password"}
                name="passwd1"
                id="passwd1"
                value={form.passwd1}
                onChange={({ target }) => setForm((val) => ({ ...val, passwd1: target.value }))} />
              <button type="button" onClick={() => setState((val) => ({ ...val, showPassw: !state.showPassw }))}>
                {
                  state.showPassw ?
                    (<EyeSlashFill />)
                    :
                    (<EyeFill />)
                }
              </button>
            </div>

            {
              listErr.length > 0 && (
                <div style={{ padding: "5px 5px 5px 25px" }}>
                  <ul className="list-err">
                    {
                      listErr.map((er, index) => (
                        <li key={index}>{er}</li>
                      ))
                    }
                  </ul>
                </div>
              )
            }

            <label style={{ cursor: "auto", fontWeight: "bold", fontSize: "16px" }} className="label-pwd" htmlFor="passwd2">{t("HomeViewComp.conf_passw")}</label>
            <input
              style={{ marginTop: "3px" }}
              className="input-control-text"
              type={state.showPassw ? "text" : "password"}
              name="passwd2"
              id="passwd2"
              value={form.passwd2}
              onChange={({ target }) => setForm((val) => ({ ...val, passwd2: target.value }))} />

            <div style={{ textAlign: "center", marginTop: "0.5rem" }}>
              {
                state.updating ? (
                  <div className="spinner-hed"></div>
                )
                  :
                  (
                    <button
                      type={((!form.passwd1.length || !form.passwd2.length) || state.updating) ? "button" : "submit"}
                      className={`btn-send-inst ${((!form.passwd1.length || !form.passwd2.length) || state.updating) ? "disabled-class" : ""}`}>{t("HomeViewComp.guard_contr")}</button>
                  )
              }
            </div>
          </form>
        )
      }
    </div>
  );
};